import { render, staticRenderFns } from "./ExamineList.vue?vue&type=template&id=278e8839&scoped=true&"
import script from "./ExamineList.vue?vue&type=script&lang=js&"
export * from "./ExamineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278e8839",
  null
  
)

export default component.exports